module.exports = __webpack_public_path__ + "img/znyy-2-sm.0a5868a5.jpg";